import React from 'react';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { GrossOfFeeIcon } from '../../../GrossOfFeeIcon/GrossOfFeeIcon';
import { ValueVsInvestmentChart } from '../../../ValueVsInvestmentChart/ValueVsInvestmentChart';
import { Card } from '../../../../../CommonComponents/OPL/Card/Card';
import styled from '../../../../../theme/theme';
import { StyledSegmentedControl } from '../../../../../CommonComponents/OPL/SegmentedControl/SegmentedControl.styles';
import { usePerformanceReportingContext } from '../../../../context/usePerformanceReportingContext';
import { usePeriodReturn } from '../../../PeriodReturn/usePeriodReturn';

export const StyledCard = styled(Card)({
  padding: 16,

  [`> ${Text}`]: {
    display: 'block',
  },

  [StyledSegmentedControl]: {
    display: 'none',
  },
});

interface Props {
  title: string;
}

export const ValueVsInvestmentCard = React.memo(({ title }: Props) => {
  const { updatedAt, selectedItemName } = usePerformanceReportingContext();

  const { data: periodReturnData } = usePeriodReturn();

  const portfolioReturn = periodReturnData?.value ? parseFloat(periodReturnData?.value) : null;

  return (
    <StyledCard>
      <Text variant="cardTitle" mb="12">
        {title}
        <GrossOfFeeIcon />
      </Text>

      <ValueVsInvestmentChart
        title={selectedItemName}
        portfolioReturn={portfolioReturn}
        updatedAt={updatedAt}
      />
    </StyledCard>
  );
});
